import { parseRuntime, ruleEngineRequest } from './impl-helper';

export const getAreaFactRender = async (params, almanac) => {
    const { variable, current } = await parseRuntime(params, almanac);


    const area = await ruleEngineRequest('area-container', 'getArea', {}, variable);

    if (current.port.id === 'default') {
        //取出除了default之外的所有port
        const others = current?.node?.data?.factInfo?.outs?.filter((port) => port.id !== 'default') || [];
        //如果其它的port都不满足条件，那么就代表命中了default条件。那么就返回true
        const isAllFalse = others.every((port) => {
            return !port?.areas?.includes(area);
        });

        if (isAllFalse) {
            return true;
        }
        return false;
    }

    const isMatch = current.port?.areas?.includes(area);
    return isMatch;

};
